import { Box, Card, Link, Typography } from '@mui/joy';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowRight, Bank, CalendarBlank, ListChecks, Wallet } from '@phosphor-icons/react';

const tools = [
  { title: 'Chart of accounts', description: 'Organize the accounts used to categorize money coming in and going out.', to: '/accounting/chart-of-accounts', icon: Bank },
  { title: 'Accounting periods', description: 'Review and manage which reporting periods are open or closed.', to: '/accounting/periods', icon: CalendarBlank },
  { title: 'Bank accounts', description: 'Connect your accounts and review imported transactions.', to: '/accounting/banking', icon: Wallet },
  { title: 'Transaction rules', description: 'Create rules to categorize matching bank transactions consistently.', to: '/accounting/banking/rules', icon: ListChecks },
];

export default function AccountingSettings() {
  return <Box>
    <Typography level="h2">Accounting setup</Typography>
    <Typography sx={{ mt: 1, mb: 3, color: 'text.secondary' }}>Choose what to configure. Each tool opens its own workspace so you can review changes before saving.</Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' }, gap: 2 }}>
      {tools.map(({ title, description, to, icon: Icon }) => <Card key={to} variant="outlined" sx={{ p: 2.5 }}>
        <Icon size={26} color="var(--joy-palette-primary-plainColor)" />
        <Typography level="title-lg">{title}</Typography>
        <Typography level="body-sm" sx={{ color: 'text.secondary', flex: 1 }}>{description}</Typography>
        <Link component={RouterLink} to={to} endDecorator={<ArrowRight />} sx={{ mt: 1 }}>Open {title.toLowerCase()}</Link>
      </Card>)}
    </Box>
  </Box>;
}
